module.exports = __webpack_public_path__ + "img/yuebei.aac9d888.png";